import { PiPButton as PiPButton$1 } from "../../../../../ui/pip-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/pip-enter.js";
import ForwardRef$1 from "../../../../../icons/dist/react/minimal/pip-exit.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/components/buttons/pip-button.tsx
/** @jsxImportSource react */
function PiPButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(PiPButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-pip-button", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-pip-button-enter-icon") }), /* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-pip-button-exit-icon") })]
	});
}
//#endregion
export { PiPButton };

//# sourceMappingURL=pip-button.js.map